import ComponentManager from '@/Management/ComponentManager';
import UIListener from '@/UIListener/UIListener';
import DetailViewContext from '@/ViewModels/Contexts/DetailViewContext';
import ControlFactory from '@/Factories/ControlFactory';

export default class TreeNodeUIListener extends UIListener {

    constructor() {
        super();
    }

    public onDetailViewReady(context: DetailViewContext) {
        (context.getUIFactory('CurrentErgNameResourceItem') as ControlFactory).isRequired(true);
    }
}

ComponentManager.setUIListener('TreeNodeUIListener', TreeNodeUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setUIListener('RADPresentation.DefaultViewExtensions.UIListener.TreeNodeUIListener', TreeNodeUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');